/* HBJ: scrollrichting → body.hbj-scroll-down (mobiele Inbox-knop verbergen bij omlaag scrollen). */
(function () {
  if (window.hbjScrollDirInit) return;
  window.hbjScrollDirInit = true;
  var last = window.scrollY;
  var ticking = false;
  function update() {
    var y = window.scrollY;
    var delta = y - last;
    if (y < 80) {
      document.body.classList.remove('hbj-scroll-down');
    } else if (delta > 8) {
      document.body.classList.add('hbj-scroll-down');
    } else if (delta < -8) {
      document.body.classList.remove('hbj-scroll-down');
    }
    if (Math.abs(delta) > 8 || y < 80) last = y;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
})();
